<template>
    <div>
        <editMortgage
            :requestParams="requestParams"
            :requestHeaders="requestHeaders"
            :portfolioResp="portfolioResp"
            :property_info="property_info"
            :editParams="editParams"
            @goToPID="goToProp"
            @updateParams="updateParams"
            v-if="switchContent == 'editMortgage'"
        />
        <editRent
            :requestParams="requestParams"
            :requestHeaders="requestHeaders"
            :portfolioResp="portfolioResp"
            :property_info="property_info"
            :editParams="editParams"
            @goToPID="goToProp"
            @updateParams="updateParams"
            v-if="switchContent == 'editRent'"
        />
        <editExpense
            :requestParams="requestParams"
            :requestHeaders="requestHeaders"
            :portfolioResp="portfolioResp"
            :property_info="property_info"
            :editParams="editParams"
            @goToPID="goToProp"
            @updateParams="updateParams"
            v-if="switchContent == 'editExpense'"
        />
        <editLayout
            :requestParams="requestParams"
            :requestHeaders="requestHeaders"
            :portfolioResp="portfolioResp"
            :property_info="property_info"
            :editParams="editParams"
            @goToPID="goToProp"
            @updateParams="updateParams"
            v-if="switchContent == 'editLayout'"
        />
    </div>
</template>
<script>
import { Message } from "element-ui";
import editLayout from "@/components/account/editLayout.vue";
import editMortgage from "@/components/account/editMortgage.vue";
import editRent from "@/components/account/editRent.vue";
import editExpense from "@/components/account/editExpense.vue";

let loading;

export default {
    name: "editPropContainer",
    props: [
        "switchContent",
        "requestParams",
        "requestHeaders",
        "portfolioResp",
        "property_info"
    ],
    data() {
        const $t = this.$t.bind(this);
        return {
            editParams: {}
        };
    },

    beforeMount() {
        this.setHttpParams();
        // this.getData();
    },

    activated() {
        this.getData();
    },

    methods: {
        updateParams(data) {
            this.loading();

            let parameters = {};
            if (data.editSelection != "expense") {
                for (const key in data.form) {
                    data.form[key] += "";
                }
            }

            if (
                data.editSelection == "mortgage" &&
                data.form.hasMortgage == "true"
            ) {
                this.$http
                    .post(
                        `${this.requestParams.ppbApi}api/v2/mortgage/${this.property_info.id}/`,
                        data.form,
                        this.requestHeaders
                    )
                    .then(resp => {
                        if (resp.status == 200) {
                            loading.close();
                            this.goToProp();
                        }
                        loading.close();
                    })
                    .catch(error => {
                        loading.close();

                        let errorMsg = "";
                        Object.values(error.data).forEach(it => {
                            errorMsg = it.toString();
                            this.triggerMessage("error", {
                                message: errorMsg
                            });
                        });
                    });
            }

            this.$http
                .patch(
                    `${this.requestParams.ppbApi}api/v2/property/${this.property_info.id}/`,
                    data.form,
                    this.requestHeaders
                )
                .then(resp => {
                    if (resp.status == 200) {
                        loading.close();
                        this.triggerMessage("success", {
                            message: this.$t("editProp.editSuccess")
                        });
                        this.goToProp();
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();

                    let errorMsg = "";
                    Object.values(error.data).forEach(it => {
                        errorMsg = it.toString();
                        this.triggerMessage("error", {
                            message: errorMsg
                        });
                    });
                });
        },

        goToProp() {
            this.$emit("linkToPID", this.property_info);
        },

        getData() {
            this.loading();

            this.$http
                .get(
                    `${this.requestParams.ppbApi}api/v2/property/${this.property_info.id}/`,
                    this.requestHeaders
                )
                .then(resp => {
                    loading.close();
                    this.editParams = resp.data;
                    this.$emit("loaded", true);
                })
                .catch(error => {
                    loading.close();

                    let errorMsg = "";
                    Object.values(error.data).forEach(it => {
                        errorMsg = it.toString();
                        this.triggerMessage("error", {
                            message: errorMsg
                        });
                    });
                });
        },

        loading() {
            loading = this.$loading({
                lock: true,
                target: ".main-container",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        setHttpParams() {
            let requestHeaders = this.requestHeaders;
            if (this.$root.cookie.acreage != "en") {
                requestHeaders.headers["Accept-Language"] = "zh-Hans";
                this.requestHeaders.headers["Accept-Language"] = "zh-Hans";
            }
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        }
    },

    components: {
        editLayout,
        editMortgage,
        editRent,
        editExpense
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/account/editPropContainer.vue